import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import {
  formatCases,
  getLineFulfillment,
} from "../../../views/orders/orderDetailsHelpers";
import OperationalDataTableSkeleton from "../../operational/OperationalDataTableSkeleton";

export default function OrderProductsTable(props) {
  const {
    loading,
    values,
    onItemEditComplete,
    askDeleteOrderItem,
    showFulfillment = false,
    allowPriceOverride = false,
    showPrices = true,
  } = props;

  const itemActionsTemplate = (data) => {
    return (
      <div className="flex">
        <button
          onClick={() => askDeleteOrderItem(data)}
          className="ml-2 rounded-md bg-red-600 px-1.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-[#FEF2F2]0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
        >
          Delete
        </button>
      </div>
    );
  };

  const textEditor = (options) => {
    return (
      <InputText
        type="text"
        value={options.value}
        onChange={(e) => options.editorCallback(e.target.value)}
        onKeyDown={(e) => e.stopPropagation()}
      />
    );
  };

  const onCellEditComplete = (e) => {
    let { rowData, rowIndex, newValue, field, originalEvent: event } = e;

    switch (field) {
      default:
        if (newValue.trim().length > 0) {
          rowData[field] = newValue;
          rowData.editedField = field;
          onItemEditComplete(rowData, rowIndex);
        } else {
          event.preventDefault();
        }
        break;
    }
  };

  const productDetailsBody = (rowData) => {
    return (
      <p>
        <span className="text-gray-900 font-semibold">
          {rowData.product_name}
        </span>
        <br />
        <span className="text-gray-700">PLU:{rowData.plu}</span>
      </p>
    );
  };

  const orderQuantityBody = (rowData) => {
    return <p>{formatCases(rowData.quantity)}</p>;
  };

  const fulfillmentBody = (field) => (rowData) => {
    const line = getLineFulfillment(rowData);
    return (
      <p className="text-right tabular-nums">{formatCases(line[field])}</p>
    );
  };

  const orderUnitCostBody = (rowData) => {
    return (
      <p>
        ${Number(rowData.unit_price ?? 0).toFixed(2)}
        {rowData.price_source && rowData.price_source !== "rule" ? (
          <span className="block text-xs text-slate-500">
            {/* Temporarily hidden Price Rules label.
            {rowData.price_source === "rule"
              ? "Price rule"
              : rowData.price_source === "manual"
                ? "Manual"
                : "List price"}
            */}
            {rowData.price_source === "manual" ? "Manual" : "List price"}
          </span>
        ) : null}
      </p>
    );
  };

  const orderTotalCostBody = (rowData) => {
    return <p>${Number(rowData.total_dollar_amount ?? 0).toFixed(2)}</p>;
  };

  const calculcateTotalCases = (products) => {
    var total = 0;
    products.forEach((item) => {
      total += parseFloat(item.quantity);
    });

    return total;
  };

  return (
    <div className="mt-5">
      <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          {loading ? (
            <OperationalDataTableSkeleton
              columns={[
                "Product",
                "Description",
                "Ordered",
                "Shipped",
                "Returned",
                "Remaining",
                "Unit Cost",
                "Total Cost",
                "Actions",
              ]}
              rows={5}
            />
          ) : (
            <div className="overflow-hidden">
              <DataTable
                value={values.products}
                dataKey="id"
                tableClassName="min-w-full bg-white divide-y divide-gray-300 text-sm create-order-inventory-table-parent"
                cellClassName="p-2 bg-white border-1-bottom-gray text-sm"
                editMode="cell"
              >
                <Column header="Product" body={productDetailsBody} />
                <Column header="Description" field="description_en" />
                <Column
                  field="quantity"
                  header={showFulfillment ? "Ordered" : "Quantity"}
                  headerClassName="order-amount-header"
                  style={{ textAlign: "right" }}
                  editor={(options) => textEditor(options)}
                  onCellEditComplete={onCellEditComplete}
                  body={orderQuantityBody}
                />

                {showFulfillment ? (
                  <>
                    <Column
                      header="Shipped"
                      headerClassName="order-amount-header"
                      style={{ textAlign: "right" }}
                      body={fulfillmentBody("shipped")}
                    />
                    <Column
                      header="Returned"
                      headerClassName="order-amount-header"
                      style={{ textAlign: "right" }}
                      body={fulfillmentBody("returned")}
                    />
                    <Column
                      header="Remaining"
                      headerClassName="order-amount-header"
                      style={{ textAlign: "right" }}
                      body={fulfillmentBody("remaining")}
                    />
                  </>
                ) : null}

                {showPrices ? (
                  <Column
                    field="unit_price"
                    header="Unit Cost"
                    headerClassName="order-amount-header"
                    style={{ textAlign: "right" }}
                    body={orderUnitCostBody}
                    editor={(options) =>
                      allowPriceOverride
                        ? textEditor(options)
                        : orderUnitCostBody(options.rowData)
                    }
                    onCellEditComplete={
                      allowPriceOverride ? onCellEditComplete : undefined
                    }
                  />
                ) : null}
                {showPrices ? (
                  <Column
                    field="quantity"
                    header="Total Cost"
                    headerClassName="order-amount-header"
                    style={{ textAlign: "right" }}
                    body={orderTotalCostBody}
                  />
                ) : null}

                <Column
                  header="Actions"
                  style={{ textAlign: "right", minWidth: "5.5rem" }}
                  body={itemActionsTemplate}
                />
              </DataTable>
              <div className="float-right py-5">
                <p className="font-bold">
                  Total Cases: {calculcateTotalCases(values.products)}
                </p>
              </div>
            </div>
          )}
          {/* <div className="w-full text-right mt-4">
              <p className="font-bold">
                Subtotal: {order.subtotal_dollar_amount}
              </p>
              <p className="font-bold">HST: 13%</p>
              <p className="font-bold">Subtotal: {order.total_dollar_amount}</p>
            </div> */}
        </div>
      </div>
    </div>
  );
}
